module.exports = __webpack_public_path__ + "media/images/demo-04b77e5a7330ea1bc4b5da38f8615f20.png";